import { render, staticRenderFns } from "./lastmile.vue?vue&type=template&id=51debdd2&scoped=true&"
import script from "./lastmile.vue?vue&type=script&lang=js&"
export * from "./lastmile.vue?vue&type=script&lang=js&"
import style0 from "./lastmile.vue?vue&type=style&index=0&id=51debdd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51debdd2",
  null
  
)

export default component.exports